import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from './components/header';
import api from './api/client';
import fard from './assets/img/fard.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

// Страница из письма сброса пароля: /reset-password/:token
function ResetPasswordPage() {
    const { token } = useParams();
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [message, setMessage] = useState('');
    const [done, setDone] = useState(false);
    const [saving, setSaving] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirm) {
            setMessage('Passwords do not match');
            return;
        }
        setSaving(true);
        setMessage('');
        try {
            const res = await api.post('/api/reset-password', { token, newPassword: password });
            setMessage(res.data.message);
            setDone(true);
        } catch (error) {
            setMessage(error.response?.data?.message || 'Error resetting password');
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <Header />
            <div className="container">
                <div className="forgot-password">
                    <div className="forgot-password__inner">
                        {done ? (
                            <div className="auth-success">
                                <FontAwesomeIcon icon={faCircleCheck} className="auth-success__icon" />
                                <p className="auth-success__text">{message}</p>
                                <Link to="/login" className="btn btn__green auth-success__btn">Sign In</Link>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <div className="container__input">
                                    <label className="label">New Password</label>
                                    <input
                                        type="password"
                                        required
                                        minLength={6}
                                        placeholder="At least 6 characters"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                <div className="container__input">
                                    <label className="label">Repeat Password</label>
                                    <input
                                        type="password"
                                        required
                                        minLength={6}
                                        placeholder="Repeat new password"
                                        value={confirm}
                                        onChange={(e) => setConfirm(e.target.value)}
                                    />
                                </div>
                                <div id="message">{message}</div>
                                <input
                                    type="submit"
                                    className="btn btn__big btn__green align-center mt-12"
                                    disabled={saving}
                                    value={saving ? 'Saving…' : 'Set New Password'}
                                />
                            </form>
                        )}
                    </div>
                    <div className="illustration">
                        <img src={fard} alt="Gardener Illustration" className="illustration_img" />
                    </div>
                </div>
            </div>
        </>
    );
}

export default ResetPasswordPage;
